import type { ReactNode } from "react";
import type { ProcessStep } from "../../lib/calculator";

export function Steps({ steps }: { steps: ProcessStep[] }) {
  return (
    <ol className="pk-steps">
      {steps.map((step, index) => (
        <li key={step.label} className={`pk-step pk-step--${step.status}`}>
          <span>{index + 1}</span>
          <p>{step.label}</p>
          <small>{step.status === "complete" ? "Complete" : step.status === "running" ? "In progress" : "Pending"}</small>
        </li>
      ))}
    </ol>
  );
}

export function StepsItem({ children }: { children: ReactNode }) {
  return <div className="pk-steps-item">{children}</div>;
}
